module.exports = __webpack_public_path__ + "img/visa-qr 1.690dd450.png";